
import FeatureDetailPage from "./FeatureDetailPage";
import { CalendarClock } from "lucide-react";
import appointmentIllustration from "./assets/appointments-illustration.svg";
const AppointmentsDetails = () => {
  return (
    <FeatureDetailPage
      icon={<CalendarClock size={32} className="text-green-400" />}
      title="Appointments"
      description="Never let an invitation slip through the cracks. Manage all incoming event and organization invites in one clean, unified dashboard. Accept, decline, and respond to questionnaires with ease."
      imageSrc={appointmentIllustration} // Replace with your actual image path
      benefits={[
        "A single, centralized inbox for all your invitations.",
        "Respond to detailed RSVP questionnaires from hosts.",
        "Easily accept or reject invites to manage your schedule.",
        "Keep track of all your upcoming commitments effortlessly.",
      ]}
    />
  );
};

export default AppointmentsDetails;
